import {
    SET_COST_CENTER_BY_MARKET
} from "./CostCenterByMarketType";

const initialState = {
    costCenterByMarket: []
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_COST_CENTER_BY_MARKET:
            return {
                ...state,
                costCenterByMarket: action.costCenterByMarket,
            };
        default:
            return state;
    }
};

export default reducer;
